import { InfoCard } from 'components/notification-cards';
import { Text } from 'components/Text';

export const ContactContentInfoCard = ({ textArr }: { textArr: string[] }) => {
  return (
    <InfoCard>
      {textArr.map(text => (
        <Text key={text} variant="body2">
          {text}
        </Text>
      ))}
    </InfoCard>
  );
};
